/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import DashboardIcon from '@mui/icons-material/DashboardOutlined';
import HomeIcon from '@mui/icons-material/HomeOutlined';
import SettingsIcon from '@mui/icons-material/SettingsOutlined';
import DesktopMacIcon from '@mui/icons-material/DesktopMac';
import ListIcon from '@mui/icons-material/List';

import config from '../../../../configuration/configuration.js';

export default [
	{
		title: '',
		pages: [
			{
				title: 'Home',
				href: '/home',
				icon: HomeIcon,
				// roles: ['Administrator', ...]
				// projects: ['Operations'],
			},
		],
	},
	{
		title: 'Menu',
		pages: [
			{
				title: 'PagerDuty Incidents',
				href: '/pagerDutyIncidents',
				icon: ListIcon,
				// roles: ['Administrator', ...]
				// projects: ['Operations'],
			},
			{
				title: 'Dashboards',
				href: '/dashboards',
				icon: DashboardIcon,
				roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
				children: [
					{
						title: 'Executive Summary',
						href: '/dashboards/executiveSummary',
					},
					{
						title: 'Alarms',
						href: '/dashboards/alarms',
					},
					{
						title: 'Incidents',
						href: '/dashboards/incidents',
						children: [
							{
								title: 'Overall',
								href: '/dashboards/incidents/overall',
							},
							{
								title: 'Monthly',
								href: '/dashboards/incidents/monthly',
							},
							{
								title: 'Weekly',
								href: '/dashboards/incidents/weekly',
							},
						]
					}
				],
			},
		],
	},
	{
		title: 'Management',
		pages: [
			{
				title: 'Manage',
				href: '/management',
				roles: ['Administrator', 'Manager'],
				icon: SupervisorAccountIcon,
				children: [
					{
						title: 'Operators',
						href: '/management/operators',
					},
					{
						title: 'Users',
						href: '/management/users',
					}
				],
			},
			{
				title: 'Hangfire',
				href: `${config.API_URL}hangfire?access_token={token}`,
				target: '_blank',
				roles: ['Administrator'],
				icon: DesktopMacIcon
			},
			{
				title: 'Settings',
				href: '/management/settings',
				icon: SettingsIcon
			},
		],
	},
];
